import React, { useState, useEffect } from "react";
import { Modal, Input, Button, ConfigProvider, message } from "antd";
import style from "css/modal.module.css";
import axios from "axios";

function EditEmailModal({ open, close, applicationId, email, productNm, refresh }) {
  const [newEmail, setNewEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setNewEmail(email || "");
    }
  }, [open, email]);

  const handleSave = () => {
    if (!newEmail || !newEmail.trim()) {
      message.warning("이메일을 입력해주세요.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail.trim())) {
      message.warning("올바른 이메일 형식을 입력해주세요.");
      return;
    }

    if (newEmail.trim() === email) {
      message.info("변경된 내용이 없습니다.");
      return;
    }

    setLoading(true);
    axios
      .post("/application/email", {
        applicationId: applicationId,
        email: newEmail.trim(),
      })
      .then((res) => {
        if (res.status === 200) {
          message.success("이메일이 수정되었습니다.");
          refresh();
          close();
        }
      })
      .catch(() => {
        message.error("이메일 수정에 실패했습니다.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={open}
      onCancel={close}
      maskClosable={true}
      width={480}
      centered
      closable={false}
      footer={null}
    >
      <div className={style.license_complete_modal}>
        <div className={style.modal_title_wrapper}>
          <span className={style.modal_title}>이메일 수정</span>
          <span className={style.modal_subtitle}>
            {productNm} 신청 이메일을 수정합니다.
          </span>
        </div>
        <div style={{ width: "100%", marginBottom: "8px" }}>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#33353b",
              marginBottom: "8px",
            }}
          >
            이메일
          </div>
          <Input
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            placeholder="이메일을 입력하세요"
            onPressEnter={handleSave}
            style={{ height: "44px", fontSize: "15px" }}
          />
        </div>
        <div className={style.modal_footer}>
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  fontFamily: "Pretendard",
                  colorPrimaryHover: "#527ff2",
                  colorPrimaryActive: "#527ff2",
                },
              },
            }}
          >
            <Button
              style={{ marginRight: "10px", width: "100px", height: "44px" }}
              onClick={close}
            >
              취소
            </Button>
            <Button
              type="primary"
              className={style.modal_submit_btn}
              onClick={handleSave}
              loading={loading}
            >
              저장
            </Button>
          </ConfigProvider>
        </div>
      </div>
    </Modal>
  );
}

export default EditEmailModal;
